<template>
  <div id="app">
    <notification-panel></notification-panel>
    <router-view></router-view>

    <prod-confirmation-window/>
  </div>
</template>

<script>
import NotificationPanel from './components/NotificationPanel.vue';
import ProdConfirmationWindow from './components/ProdConfirmationWindow.vue';

export default {
  components: {
    NotificationPanel,
    ProdConfirmationWindow,
  }
}
</script>

<style>
body {
  padding-top: 0px;
}
</style>
